// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function emptyPlans(param) {
  return /* [] */0;
}

function featureNameDecode(featureName) {
  switch (featureName) {
    case "admin_pages" :
        return "AdminPages";
    case "custom_reports" :
        return "CustomReports";
    case "dashboard" :
        return "Dashboard";
    case "kpi_management" :
        return "KpiManagement";
    case "quick_survey" :
        return "QuickSurvey";
    case "reports" :
        return "Reports";
    case "signup_link" :
        return "SignupLink";
    case "survey_logic" :
        return "SurveyLogic";
    case "tickets" :
        return "Tickets";
    default:
      return "DummyFeature";
  }
}

function fromJson(json) {
  return {
          feature: featureNameDecode(Json_decode.field("feature", Json_decode.string, json)),
          description: Json_decode.field("description", Json_decode.string, json),
          enabled: Json_decode.field("enabled", Json_decode.bool, json)
        };
}

function decode(json) {
  return Json_decode.field("subscription_plans", (function (param) {
                return Json_decode.list(fromJson, param);
              }), json);
}

function isEnabled(subscriptionPlans, featureName) {
  var requiredFeature = List.find_opt((function (rf) {
          return rf.feature === featureName;
        }), subscriptionPlans);
  if (requiredFeature !== undefined) {
    return requiredFeature.enabled;
  } else {
    return false;
  }
}

exports.emptyPlans = emptyPlans;
exports.isEnabled = isEnabled;
exports.decode = decode;
/* No side effect */
